import React, { useState, useEffect } from 'react';
import HomePhoto1 from "../assets/home_images/HomePhoto1.jpg";
import HomePhoto2 from "../assets/home_images/HomePhoto2.jpg";
import HomePhoto3 from "../assets/home_images/HomePhoto3.jpg";
import HomePhoto4 from "../assets/home_images/HomePhoto4.jpg";
import HomePhoto5 from "../assets/home_images/HomePhoto5.jpg";

function ImageCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    { url: HomePhoto1, alt: "HomePhoto1" },
    { url: HomePhoto2, alt: "HomePhoto2" },
    { url: HomePhoto3, alt: "HomePhoto3" },
    { url: HomePhoto4, alt: "HomePhoto4" },
    { url: HomePhoto5, alt: "HomePhoto5" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 6000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="relative h-full w-full overflow-hidden bg-gray-900">
      {images.map((image, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-[1500ms] ease-in-out ${
            currentIndex === index ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={image.url}
            alt={image.alt}
            className={`w-full h-full object-cover object-center ${
              currentIndex === index ? 'animate-kenburns' : ''
            }`}
          />
        </div>
      ))}

      {/* Subtle progress indicators (bottom-center) */}
      <div className="absolute bottom-3 sm:bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5 z-10">
        {images.map((_, index) => (
          <div
            key={index}
            className={`h-1 rounded-full transition-all duration-500 ${
              currentIndex === index
                ? 'w-8 bg-[#FED700]'
                : 'w-4 bg-white/40'
            }`}
            aria-hidden="true"
          />
        ))}
      </div>
    </div>
  );
}

export default ImageCarousel;
